import { render, staticRenderFns } from "./configurar.vue?vue&type=template&id=23369b98&scoped=true&"
import script from "./configurar.vue?vue&type=script&lang=js&"
export * from "./configurar.vue?vue&type=script&lang=js&"
import style0 from "./configurar.vue?vue&type=style&index=0&id=23369b98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23369b98",
  null
  
)

export default component.exports